import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, Navigation } from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "../../assets/css/slider.css";

const BannerComponent = () => {
  let navigate = useNavigate();

  const [tickerKey, setTickerKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTickerKey((prevKey) => prevKey + 1);
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  const [inputTrack, setInputTrack] = useState();
  return (
    <div>
      {/* <div className="ticker-wrapper" key={tickerKey}>
        <div className="text-update">
          <p>
            Some deliveries may be delayed due to foggy weather.
            <span style={{ fontSize: "1rem", margin: "0 2%" }}>
              موسم دھند آلود ہونے کی وجہ سے کچھ ترسیلات میں تاخیر ہو سکتی ہے۔
            </span>
          </p>
        </div>
      </div> */}

      <div className="ticker-wrapper  overflow-hidden ">
        <div className="ticker">
          <div className="ticker__item">
            <p className="font-bold text-[12px]  ">
              {/* Dear Cricket Fans, The e-ticketing system has now been restored.
              Please revisit your download link to access and print your ticket.
              In case you are unable to print it, your Email Confirmation will
              also be accepted at the stadium gates. We look forward to seeing
              you at the stadium! */}
              <span className="font-bold text-[12px] ml-[3%]">
                Beware of fake calls or messages asking you to click on links,
                share payments, OTPs, or personal details. TCS never asks for
                such details. Our riders only call to confirm name & address
              </span>
            </p>
          </div>
        </div>
      </div>

      <div
        id="banner-1"
        className="mobile-banner md:hidden flex hm-banner bg-center bg-no-repeat w-full justify-center items-center zoom "
      >
        <>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img
                src="/Home/ecom_mobile.jpg"
                className="md:hidden flex"
                alt="fogEng"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/Raastmobile.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="/Home/fortymobile.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>

            {/* <SwiperSlide>
              <img
                src="/Home/mobile-cod.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide> */}
            <SwiperSlide>
              <img
                src="/Home/responsive-banner6.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner2.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner3.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner4.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="/Home/responsive-banner5.jpg"
                className="md:hidden flex"
                alt="banner"
              />
            </SwiperSlide>
          </Swiper>
        </>
        <div
          className="hidden sm:hidden lg:flex  lg:mt-[-5rem] md:mt-[-3rem]  sm:mt-[1rem] mt-[13rem] text-center md:text-left absolute"
          style={{ zIndex: 9 }}
        >
          <h2 className="banner-heading react-reveal text-white text-3xl sm:text-2xl font-semibold">
            Track Your Shipment
          </h2>
          <div className="banner-input react-reveal text-sm flex flex-col md:flex-row">
            <input
              onChange={(e) => {
                console.log(e);
                setInputTrack(e.target.value);
              }}
              type="number"
              placeholder="Enter your Tracking Number"
              className="p-3 md:w-[30rem] focus:outline-none opacity-75 rounded-l-sm"
              onKeyDown={(e) =>
                e?.key === "Enter" &&
                inputTrack &&
                navigate(`/track/${inputTrack}`)
              }
            />
            <button
              onClick={() => inputTrack && navigate(`/track/${inputTrack}`)}
              type="button"
              className="bg-[#D40511] text-white p-3 w-full md:w-[10rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>

      <div className="web-banner md:flex hidden hm-banner bg-center bg-no-repeat w-full  md:justify-center items-center zoom">
        <>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: false,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper "
          >
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/ecom_banner.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/Raastbanner.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/fortybanner.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>

            {/* <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-cod.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide> */}
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/sliderbanner1.jpg"
                className="lg:block hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner2.jpg"
                className="lg:flex hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner3.jpg"
                className="lg:flex hidden"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/sliderbanner6.jpg"
                className="lg:block hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner2.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner3.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/slider-banner5.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-banner md:flex hidden">
              <img
                src="/Home/banner-new.jpg"
                className="lg:flex hidden"
                alt="banner"
              />
            </SwiperSlide>
          </Swiper>
        </>
        <div
          className="hidden sm:block lg:mt-[-5rem] md:mt-[-3rem]  sm:mt-[1rem] mt-[13rem] text-center md:text-left absolute"
          style={{ zIndex: 9 }}
        >
          <h2 className="banner-heading react-reveal text-white text-3xl sm:text-2xl font-semibold">
            Track Your Shipment
          </h2>
          <div className="banner-input react-reveal text-sm flex flex-col md:flex-row">
            <input
              type="number"
              onChange={(e) => {
                setInputTrack(e.target.value);
              }}
              placeholder="Enter your Tracking Number"
              className="p-3 md:w-[30rem] focus:outline-none opacity-75 rounded-l-sm"
              onKeyDown={(e) =>
                e?.key === "Enter" &&
                inputTrack &&
                navigate(`/track/${inputTrack}`)
              }
            />
            <button
              onClick={() => inputTrack && navigate(`/track/${inputTrack}`)}
              type="button"
              className="bg-[#D40511] text-white p-3 w-full md:w-[10rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerComponent;
